import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import AsyncSelectInput from "../../../components/Form/Select/AsyncSelect"
import { iResponse } from "../../../definitions/interfaces"
import { iRoles } from "../../../definitions/Roles"
import { get } from "../../../store/data/actions"

const UserAdministration = () => {
  const { control } = useFormContext()
  const loadRoles = async (input: string) => {
    const result = await get<iResponse<iRoles[]>>({
      link: "/v1/roles-list",
      query: { name: input },
    })
    return result.data
  }
  return (
    <div className="scrollable">
      <Controller
        control={control}
        name="roles"
        render={({ value, onChange }) => (
          <AsyncSelectInput
            value={value}
            onChange={onChange}
            loadOptions={loadRoles}
            name="roles"
            label="User role"
            defaultOptions
            isMulti
          />
        )}
      />
    </div>
  )
}

export default UserAdministration
